/** @jsx jsx */
import React, { useState, useEffect, useRef } from 'react';
import { jsx, Box, Flex, Text, Button, Checkbox, Label, SxProps } from 'theme-ui';
import translate from '../../../shared/translate';

export const FilterSelect: React.FC<{ title: string, sx?: SxProps }> = ({ children, title, sx }) => {
  const filterSelectRef = useRef(null);
  const [showOverlay, setOverlay] = useState(false);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    const handleClickOutside: React.EventHandler<any> = (event) => {
      if (
        filterSelectRef.current &&
        !filterSelectRef.current.contains(event.target)
      ) {
        setOverlay(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [filterSelectRef]);

  return (
    <Box ref={filterSelectRef} sx={{ position: ['static', 'static', 'relative'], ...sx }}>
      <Flex
        sx={{ alignItems: 'center', bg: 'foreground', color: 'black', p: 3 }}
        onClick={() => setOverlay(!showOverlay)}
      >
        <Text sx={{ flexGrow: 1, fontSize: 3 }}>{translate(title)}</Text>
        <Button
          onClick={() => setOverlay(!showOverlay)}
          sx={{ border: 0, color: 'black', outline: 'none' }}
        >
          {showOverlay ? '▲' : '▼'}
        </Button>
      </Flex>
      {showOverlay && (
        <Box
          sx={{
            zIndex: 100,
            position: ['static', 'static', 'absolute'],
            bg: 'foreground',
            borderColor: 'black',
            borderWidth: 1,
            width: '100%',
            color: 'black',
            p: 3,
            pt: 0,
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};

export const FilterOption: React.FC<React.InputHTMLAttributes<any>> = ({
  children,
  ...props
}) => {
  return (
    <Label
      sx={{
        display: 'flex',
        alignItems: 'center',
        bg: 'foreground',
        color: 'black',
        pt: 3,
        pb: 3,
      }}
    >
      <Text sx={{ flexGrow: 1 }}>{children}</Text>
      <Checkbox
        sx={{
          borderColor: 'black',
          borderWidth: 1,
          bg: 'foreground',
        }}
        {...props}
      />
    </Label>
  );
};
